export default "__VITE_ASSET__BCexOLo8__"